import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { useProductDetailsHeaderTagsStyles } from './productDetailsHeaderTags.styles';
import { ProductDetailsHeaderTagsProps } from './productDetailsHeaderTags.types';
import { toHeaderTagViews } from './productDetailsHeaderTags.utils';

const ProductDetailsHeaderTags = ({ tags }: ProductDetailsHeaderTagsProps) => {
  const { classes } = useProductDetailsHeaderTagsStyles();
  const headerTags = toHeaderTagViews(tags ?? []);

  if (headerTags.length === 0) {
    return null;
  }

  return (
    <Stack
      flex={1}
      direction="row"
      alignItems="center"
      gap={0.75}
      minWidth={0}
      overflow="hidden"
      className={classes.container}
    >
      {headerTags.map((tag) => (
        <Tooltip key={tag.id} TooltipContent={tag.description} tabIndex={-1}>
          <LabeledChip
            content={tag.label}
            appearance="plain"
            className={classes.tag}
            sx={{ color: tag.fontColor, backgroundColor: tag.backgroundColor }}
          />
        </Tooltip>
      ))}
    </Stack>
  );
};

export default memo(ProductDetailsHeaderTags);
